export { TextArea } from './text-area';
export type { TextAreaProps } from './text-area';
